import React from "react";
import { defineMessages } from "react-intl";
import { Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { OutlinedButton } from "../button/Buttons.js";
import "../button/EditButton.js";
import { DropzoneContentDefault } from "./DropzoneContentDefault.js";
import { DropzoneContentFailed } from "./DropzoneContentFailed.js";
import { DropzoneContentSuccess } from "./DropzoneContentSuccess.js";
const localized = defineMessages({
  dropzoneContentReloadFileButton: {
    id: "DZ_reloadFileButton",
    defaultMessage: "Reload File"
  }
});
const useClasses = makeStyles()((theme) => ({
  dropzoneContentContainer: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
  },
  dropzoneContentSuccess: {
    color: theme.palette.success.main
  },
  dropzoneContentReject: {
    color: theme.custom.palette.status.bronze.main
  },
  dropzoneContentReloadFile: {
    position: "absolute",
    top: 0,
    right: 0,
    margin: theme.spacing(2.5)
  },
  dropzoneContentReloadFileButton: {
    fontWeight: 500
  }
}));
function DropzoneContent({ successFile, rejectFile, isDragOrDialogActive, onOpen, editMode }) {
  const { classes, cx } = useClasses();
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(
        editMode === "Failed" ? classes.dropzoneContentReject : "",
        editMode === "Success" ? classes.dropzoneContentSuccess : "",
        classes.dropzoneContentContainer
      )
    },
    successFile || rejectFile ? /* @__PURE__ */ React.createElement(Box, { className: classes.dropzoneContentReloadFile }, /* @__PURE__ */ React.createElement(
      OutlinedButton,
      {
        className: classes.dropzoneContentReloadFileButton,
        label: localized.dropzoneContentReloadFileButton,
        onClick: onOpen
      }
    )) : null,
    editMode === "Failed" ? /* @__PURE__ */ React.createElement(DropzoneContentFailed, { rejectFile }) : editMode === "Success" ? /* @__PURE__ */ React.createElement(DropzoneContentSuccess, { file: successFile }) : /* @__PURE__ */ React.createElement(DropzoneContentDefault, { isDragOrDialogActive, onOpen })
  );
}
export {
  DropzoneContent
};
//# sourceMappingURL=DropzoneContent.js.map
